import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f6d39568&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f6d39568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d39568",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6d39568')) {
      api.createRecord('f6d39568', component.options)
    } else {
      api.reload('f6d39568', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f6d39568&scoped=true&", function () {
      api.rerender('f6d39568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/corporate-recharge-detail/index.vue"
export default component.exports